import React from 'react';

export default props => (
    <svg viewBox="0 0 38 38" {...props}>
        <path fill="#FFF"
              d="M26.102 12.785a1.78 1.78 0 0 1 1.776 1.776v10.654a1.78 1.78 0 0 1-1.776 1.775H11.898a1.78 1.78 0 0 1-1.776-1.775V14.56a1.78 1.78 0 0 1 1.776-1.776h2.814l1.625-1.775h5.326l1.625 1.775h2.814zM13.7 19.872c0 1.302.536 2.474 1.39 3.322l-1.39 1.39h3.534V21.05l-1.32 1.32a3.528 3.528 0 0 1 1.32-5.825v-1.231a4.709 4.709 0 0 0-3.534 4.558zm10.602-4.712h-3.534v3.534l1.32-1.319a3.528 3.528 0 0 1-1.32 5.825v1.231a4.709 4.709 0 0 0 3.534-4.559 4.668 4.668 0 0 0-1.39-3.322l1.39-1.39z"/>
    </svg>
);